import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeviceGeofenceService {
  private deviceGeofenceUrl: string = environment.geofenceActivation;

  constructor(private httpClient: HttpClient) {}

  getActivations(
    serialNumber?: string,
    startDate?: string,
    endDate?: string,
  ): Promise<Activation[]> {
    let params = new HttpParams();

    Object.entries({ serialNumber, startDate, endDate }).forEach(
      ([key, value]) => {
        if (value === null || value === undefined) return;

        params = params.append(key, value);
      },
    );

    return this.httpClient
      .get<Activation[]>(`${this.deviceGeofenceUrl}/activations`, { params })
      .toPromise();
  }

  getGeofenceByFenceId(fenceId: string): Promise<GeofenceResponse> {
    return this.httpClient
      .get<GeofenceResponse>(`${this.deviceGeofenceUrl}/geofences/${fenceId}`)
      .toPromise();
  }
}

export interface GeofenceResponse {
  properties: GeofenceProperties;
  geometry: Geometry;
  type: string;
}

export interface Geometry {
  coordinates: Coordinates[][];
}

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface GeofenceProperties {
  id: string;
  topic: string;
}

export interface Activation {
  serialNumber: string;
  timestamp: string;
  fenceId: string;
  crossing: Crossing;
  offset: Offset;
}

export interface Crossing {
  crossedInto: boolean;
  segment: CrossingSegment[];
}

export interface CrossingSegment {
  timestamp: string;
  latitude: number;
  longitude: number;
}

export interface Offset {
  latitude: number;
  longitude: number;
}
